<template>
  <div class="">
    <b-button v-b-toggle.placesWorkPlansDays class="btn btn-lg btn-collapse">
      {{ $t("placesWorkPlansDays") }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </b-button>
    <b-collapse id="placesWorkPlansDays">
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-md-6 col-lg-6">
            <input
              type="checkbox"
              id="placesWorkPlansDaysView"
              v-model="
                usersPrivilegePlacesWorkPlansDays.placesWorkPlansDaysView
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placesWorkPlansDaysView">{{
              $t("view")
            }}</label>
          </div>
          <div class="form-label-group col-md-6 col-lg-6">
            <input
              type="checkbox"
              id="placesWorkPlansDaysUpdate"
              v-model="
                usersPrivilegePlacesWorkPlansDays.placesWorkPlansDaysUpdate
              "
              class="checkbox"
            />
            <label class="mt-1 ml-2" for="placesWorkPlansDaysUpdate">{{
              $t("add")
            }}</label>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "UsersPrivilegePlacesWorkPlansDays",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
    };
  },
  props: ["usersPrivilegePlacesWorkPlansDays"],
  methods: {},
};
</script>

<style scoped lang="scss"></style>
